import { FC } from "react";
import { Button, Text } from "@chakra-ui/react";

import { CaseDocumentModel } from "@shared/models";
import { CaseDocumentActions } from "@containers/Cases/interface";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";
import { getUSFormatedTime } from "@shared/utils";

import ActionLink from "./CaseDocumentActionLink";
import { formatDocumentDate } from "./CaseDocuments.utils";
import CaseDocumentCardFrame from "./CaseDocumentCardFrame";
import CaseDocumentCardActions from "./CaseDocumentCardActions";

const getFailedSummary = (fileCount: number) =>
  fileCount === 1 ? "We couldn’t read the file." : `We couldn’t read any of the ${fileCount} files.`;

interface CaseDocumentFailedCardProps {
  caseDocument: CaseDocumentModel;
  actions: CaseDocumentActions;
}

const CaseDocumentFailedCard: FC<CaseDocumentFailedCardProps> = ({ caseDocument, actions }) => {
  const { kind, files, error_message, failed_at } = caseDocument;
  const { retry, replace, remove } = actions;

  return (
    <CaseDocumentCardFrame caseDocument={caseDocument} borderColor="brand.error/30" bg="score.lowBg/40">
      <Text fontSize="13px" lineHeight={1.5} color="brand.modalHeaderText">
        <Text as="span" fontWeight={FONT_WEIGHT.HEAVY}>
          {getFailedSummary(files.length)}
        </Text>{" "}
        {error_message && `${error_message} `}Your files are kept and no fields were changed.
      </Text>
      {failed_at && (
        <Text fontSize="12px" color="brand.emptyStateText">
          Failed {formatDocumentDate(failed_at)} · {getUSFormatedTime(failed_at)}
        </Text>
      )}
      <CaseDocumentCardActions>
        <Button variant="primary" h="32px" px="14px" fontSize="13px" disabled={!retry} onClick={() => retry?.(kind)}>
          Retry
        </Button>
        <ActionLink disabled={!replace} onClick={() => replace?.(kind)}>
          Replace files
        </ActionLink>
        <ActionLink color="brand.emptyStateText" disabled={!remove} onClick={() => remove?.(kind)}>
          Remove
        </ActionLink>
      </CaseDocumentCardActions>
    </CaseDocumentCardFrame>
  );
};

export default CaseDocumentFailedCard;
